import { Modal } from 'antd';

const DEFAULT_Z = 14000;

function showObdQuoteModal(
    type: 'warning' | 'info',
    title: string,
    content: string,
    theme: string,
    zIndex = DEFAULT_Z,
): void {
    const config = {
        title,
        content,
        okText: 'OK',
        centered: true,
        zIndex,
        className: `obd-quote-design-blocked-modal obd-theme-${theme}`,
        rootClassName: `obd-theme-${theme}`,
    };
    if (type === 'info') {
        Modal.info(config);
        return;
    }
    Modal.warning(config);
}

export function showObdQuoteWarningModal(
    title: string,
    content: string,
    theme: string,
    zIndex = DEFAULT_Z,
): void {
    showObdQuoteModal('warning', title, content, theme, zIndex);
}

export function showObdQuoteInfoModal(
    title: string,
    content: string,
    theme: string,
    zIndex = DEFAULT_Z,
): void {
    showObdQuoteModal('info', title, content, theme, zIndex);
}

export const FINANCE_PARTNER_MISMATCHED_TITLE = 'Finance Partner Mismatched';
export const FINANCE_PARTNER_MISMATCHED_MESSAGE =
    'Finance partner does not match with selected product';

export function showFinancePartnerMismatchModal(theme: string): void {
    showObdQuoteWarningModal(
        FINANCE_PARTNER_MISMATCHED_TITLE,
        FINANCE_PARTNER_MISMATCHED_MESSAGE,
        theme,
    );
}

export function showInvalidQuoteCombinationModal(description: string, theme: string): void {
    showObdQuoteWarningModal('Invalid Quote Combination', description, theme);
}

export function showFinanceMethodMismatchModal(
    theme: string,
    description = 'Selected finance method does not match with suggested finance method. Please update the finance method accordingly.',
): void {
    showObdQuoteWarningModal('Finance Method Missmatch', description, theme);
}

export function showFinanceMethodMismatchedModal(theme: string): void {
    showObdQuoteWarningModal(
        'Finance Methord Mismatched',
        'Finance methord does not match with selected product',
        theme,
    );
}

export function showFinancePartnerSyncRequiredModal(
    theme: string,
    description = 'Complete the partner checklist for your selected finance partner(s) before adding quotes.',
): void {
    showObdQuoteWarningModal('Finance Partner Sync required', description, theme);
}

export function showProductNotSelectedModal(theme: string): void {
    showObdQuoteWarningModal(
        'Product not selected',
        'Product not found in the selected products',
        theme,
    );
}

export function showPartnerSyncRequiredModal(
    theme: string,
    description = 'Complete Partner Sync before generating a quote.',
): void {
    showObdQuoteWarningModal('Partner Sync required', description, theme);
}

export function showNoRecommendedPricingModal(theme: string): void {
    showObdQuoteInfoModal(
        'No recommended pricing',
        'Load pricing or open Best pricing options before generating a quote.',
        theme,
    );
}

export function showUnableToOpenQuoteFormModal(theme: string): void {
    showObdQuoteWarningModal(
        'Unable to open quote form',
        'Could not match the selected plan products to active opportunity products. Confirm partner and method are saved for each product.',
        theme,
    );
}

export function showPricingNotFoundModal(theme: string): void {
    showObdQuoteWarningModal(
        'Pricing not found',
        'Could not find this plan in the current pricing grid.',
        theme,
    );
}
